export const styles = {
    membershipInfoContainer: {
        borderBottom: "1px solid gray",
    },
    memberOnlybenefitsItemContainer: {
        borderColor: "gray.100",
    },
};
